import { motion } from 'framer-motion';

function Logo({ className = "h-9 w-auto" }) {
  return (
    <div className="flex items-center justify-center gap-2">
      <img src="/logo.png" alt="NCAI" className={className} />
    </div>
  );
}

function Preloader() {
  return (
    <motion.div
      className="fixed inset-0 z-50 flex items-center justify-center bg-gradient-to-b from-slate-50 via-white to-slate-50"
      initial={{ opacity: 1 }}
      exit={{ opacity: 0 }}
      transition={{ duration: 0.5 }}
    >
      <div className="text-center">
        <div className="relative rounded-full h-32 w-32 mx-auto mb-4 flex items-center justify-center">
          <div className="absolute inset-0 rounded-full border-4 border-indigo-600 border-t-transparent animate-spin"></div>
          <div className="relative z-10 bg-white rounded-full h-28 w-28 flex items-center justify-center">
            <Logo className="h-12 w-auto" />
          </div>
        </div>
      </div>
    </motion.div>
  );
}

export default Preloader;